import React, { useState } from "react";
import PropTypes from "prop-types";
import ScoringDimensionPeriodListComponent from "./ScoringDimensionPeriodListComponent";
import * as editableDocument from "utils/model/editableDocument";
import { collection } from "utils/immutable";
import { getRandomInt } from "utils/functions";
import flow from "lodash.flow";
import { isMandatory, isInRange } from "utils/simple-validations";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showInfo } from "actions/actionCreators/snackbarActions";

const getPeriodDimensionItemValidationRules = () => ({
  dimensionPeriodYear: document => (document.selected ? [isMandatory(), isInRange(1700, 4000)] : []),
  dimensionPeriodMonth: document => (document.selected ? [isMandatory(), isInRange(1, 12)] : [])
});

const getPeriodDimensionBusinessRules = dimensions => ({
  dimensionPeriodName: document => (document.dimensionPeriodYear || "") + "." + (document.dimensionPeriodMonth || ""),
  dimensionPeriodCode: document => (document.dimensionPeriodYear || "") + (document.dimensionPeriodMonth || ""),
  dimensionName: document => {
    var dimensionToUpdate = dimensions.find(x => x.id === document.dimensionId);
    return dimensionToUpdate && dimensionToUpdate.name;
  }
});

const ScoringDimensionPeriodListContainer = ({
  showModal,
  dimensions,
  periods,
  onCloseDimensionListModal
}) => {
  const [state, setState] = useState({
    localPeriods: periods.map(editableDocument.create),
    prevLocalPeriods: periods.map(editableDocument.create)
  });

  const onPeriodDimensionChange = idx => (prop, value) => {
    let updateAndValidate = flow(
      editableDocument.update(prop, value, getPeriodDimensionBusinessRules(dimensions)),
      editableDocument.validate(getPeriodDimensionItemValidationRules(), false)
    );

    setState({
      ...state,
      localPeriods: collection.update(idx, updateAndValidate, state.localPeriods)
    });
  };

  const onCloseLocalPeriodDimensions = () => {
    setState({
      ...state,
      localPeriods: state.prevLocalPeriods
    });

    onCloseDimensionListModal();
  };

  const onAddNewPeriodDimension = () => {
    const newPeriodDimension = flow(
      editableDocument.create,
      editableDocument.validate(getPeriodDimensionItemValidationRules(), false)
    )({
      dimensionId: null,
      dimensionName: null,
      dimensionPeriodId: getRandomInt(10000, 2147483647),
      dimensionPeriodMonth: null,
      dimensionPeriodName: null,
      dimensionPeriodSourceId: -1,
      dimensionPeriodSourceName: "Manual",
      dimensionPeriodYear: null,
      documentScoringFinancialIndicatorPeriodDimensionId: getRandomInt(10000, 2147483647),
      selected: true,
      isReadOnly: false
    });

    setState({
      ...state,
      localPeriods: collection.insert(state.localPeriods.length, newPeriodDimension, state.localPeriods)
    });
  };

  return (
    <ScoringDimensionPeriodListComponent
      showModal={showModal}
      dimensions={dimensions}
      onCloseLocalDimensionListModal={onCloseLocalPeriodDimensions}
      onAddNewPeriodDimension={onAddNewPeriodDimension}
      onPeriodDimensionChange={onPeriodDimensionChange}
      periods={state.localPeriods || []}
    />
  );
};

ScoringDimensionPeriodListContainer.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onCloseDimensionListModal: PropTypes.func.isRequired,
  dimensions: PropTypes.array,
  periods: PropTypes.array.isRequired,
  actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ showInfo }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(ScoringDimensionPeriodListContainer);
